function finiteMillis(value,label='timestamp'){
  if(value instanceof Date){
    const millis=value.getTime();
    if(!Number.isFinite(millis))throw new TypeError(label+' is invalid');
    return millis;
  }
  if(typeof value==='number'){
    if(!Number.isFinite(value))throw new TypeError(label+' is invalid');
    return value;
  }
  const text=String(value||'').trim();
  const millis=Date.parse(text);
  if(!text||Number.isNaN(millis))throw new TypeError(label+' must be a valid timestamp');
  return millis;
}

export function timezoneSafeTimestamp(value,label='timestamp'){
  const text=String(value||'').trim();
  if(!text||Number.isNaN(Date.parse(text))){
    throw new TypeError(label+' must be a valid ISO timestamp');
  }
  if(!/(?:Z|[+-]\d{2}:\d{2})$/i.test(text)){
    throw new TypeError(label+' must include an explicit timezone offset');
  }
  return text;
}

export function instantMillis(value,label='timestamp'){
  return finiteMillis(value,label);
}

export function formatLocalInstant(value,{
  locale='pl-PL',
  timeZone=undefined,
  options={}
}={}){
  const millis=finiteMillis(value,'timestamp');
  return new Intl.DateTimeFormat(locale,{
    ...(timeZone?{timeZone}:{}),
    ...options
  }).format(new Date(millis));
}

export function createClockIntegrityMonitor({
  wallNow=Date.now,
  monotonicNow=()=>globalThis.performance?.now?.()??Date.now(),
  thresholdMs=90_000
}={}){
  if(typeof wallNow!=='function')throw new TypeError('wallNow must be a function');
  if(typeof monotonicNow!=='function')throw new TypeError('monotonicNow must be a function');
  const threshold=Number(thresholdMs);
  if(!Number.isFinite(threshold)||threshold<1_000)throw new TypeError('thresholdMs must be at least 1000');

  let anchor=null;

  function reset(){
    anchor=null;
  }

  function observe(){
    const wall=finiteMillis(wallNow(),'wallNow');
    const monotonic=Number(monotonicNow());
    if(!Number.isFinite(monotonic))throw new TypeError('monotonicNow is invalid');

    if(!anchor){
      anchor={wall,monotonic,effective:wall};
      return Object.freeze({
        status:'ok',
        wallNowMillis:wall,
        effectiveNowMillis:wall,
        driftMs:0,
        direction:null
      });
    }

    const monotonicDelta=monotonic-anchor.monotonic;
    if(monotonicDelta<0){
      anchor={wall,monotonic,effective:wall};
      return Object.freeze({
        status:'reset',
        wallNowMillis:wall,
        effectiveNowMillis:wall,
        driftMs:0,
        direction:null
      });
    }

    const predicted=anchor.effective+monotonicDelta;
    const drift=wall-predicted;
    const jumped=Math.abs(drift)>=threshold;
    const effective=jumped?predicted:wall;

    anchor={wall,monotonic,effective};
    return Object.freeze({
      status:jumped?'clock_jump':'ok',
      wallNowMillis:wall,
      effectiveNowMillis:effective,
      driftMs:jumped?drift:0,
      direction:jumped?(drift>0?'forward':'backward'):null
    });
  }

  return Object.freeze({observe,reset});
}
